export const team = [
  {
    name: "Liam Ottley",
    photo: "/images/Photos/Team/1.png",
    role: "CEO",
    description: [
      "Strategic entrepreneur and AI advocate, who has been developing web and mobile apps since he was just a kid. With a diverse background in e-commerce, marketing, and AI development, Liam has a proven track record of leading successful projects and fostering innovation across various industries.",
      "With a deep understanding of the factors that drive success in the marketplace and the importance of effectively communicating AI's transformative potential, Liam's mission is to enable individuals and businesses across industries to harness the power of AI enabling growth and innovation.",
      "His experience in the field has inspired him to create a YouTube channel that serves as an educational platform. Liam's vision is for everyone to be well-versed in AI, as he believes that understanding its potential is crucial for success in the ever-evolving marketplace."
    ],
    links: [
      "https://facebook.com/",
      "https://twitter.com/",
      "https://portfolio.com/",
    ],
  },
  {
    name: "Josh Brown",
    photo: "/images/Photos/Team/2.png",
    role: "Head of Operations",
    description: [
      "As an accomplished entrepreneur and founder of JB Media, Josh brings extensive experience in e-commerce and digital marketing to our team, making him the ideal fit for overseeing our operations.",
      "Josh founded his first e-commerce brand at the age of 18, transforming a $1,400 investment into $1.2 million in revenue in just five months. Since then, he has expanded his e-commerce portfolio, creating five more brands across various industries, including travel, health and wellness, and cosmetics.",
      "With an impressive track record in managing and growing businesses showcases his ability to strategize, execute, and optimize processes at Morningside AI. His expertise in scaling businesses, enables him to effectively lead our operations and ensure the seamless delivery of cutting-edge AI solutions to clients."
    ],
    links: [
      "https://facebook.com/",
      "https://twitter.com/",
      "https://portfolio.com/",
    ],
  },
  {
    name: "Nikhil Bery",
    photo: "/images/Photos/Team/3.png",
    role: "Lead Developer",
    description: [
      "Full Stack Developer with over 10 years of experience in the field. Intrigued by the potential of AI, he decided to dive into the world of programming and has since dedicated his career to creating innovative solutions that harness the power of AI. Throughout his career, Nikhil has worked on an extensive array of AI-driven projects, including advanced natural language processing applications, intelligent chatbots, predictive analytics, and computer vision systems that help businesses optimize their processes. His expertise in AI development is bolstered by his proficiency in various programming languages, frameworks, and tools.",
      "Nikhil is highly skilled in AI technologies such as OpenAI, ChatGPT, NLP, and Deep Learning. He is also proficient in programming languages like Python, JavaScript, and C++, and well-versed in machine learning libraries and frameworks such as TensorFlow, PyTorch, and scikit-learn. Additionally, Nikhil is adept at using tools like Keras and NLTK to build and fine-tune AI models.",
      "His comprehensive skillset enables him to develop AI solutions from the ground up, ensuring seamless integration and maximum efficiency."
    ],
    links: [
      "https://facebook.com/",
      "https://twitter.com/",
      "https://portfolio.com/",
    ],
  },
];
